// Spanish translation dictionary. Keys are the English source strings.
// Anything not found falls back to English automatically.
export const ES = {
  // Nav
  "Dashboard": "Panel", "Customers": "Clientes", "Call Center": "Centro de Llamadas",
  "Estimates": "Presupuestos", "Schedule": "Agenda", "Services": "Servicios",
  "Invoices": "Facturas", "Payments": "Pagos", "Employees": "Empleados",
  "Payroll": "Nómina", "Reviews": "Reseñas", "Reports": "Reportes", "Settings": "Configuración",
  "Administrator": "Administrador", "Sign Out": "Cerrar Sesión",

  // Common
  "Save": "Guardar", "Cancel": "Cancelar", "Edit": "Editar", "Delete": "Eliminar",
  "Save Changes": "Guardar Cambios", "Actions": "Acciones", "Status": "Estado",
  "Search jobs, customers, crews...": "Buscar trabajos, clientes, equipos...",
  "Name": "Nombre", "Full Name": "Nombre Completo", "Full Name *": "Nombre Completo *",
  "Phone": "Teléfono", "Email": "Correo", "Address": "Dirección", "City": "Ciudad",
  "State": "Estado", "ZIP": "Código Postal", "Notes": "Notas", "Date": "Fecha",
  "Amount": "Monto", "Amount ($)": "Monto ($)", "Method": "Método", "Contact": "Contacto",
  "Location": "Ubicación", "Customer": "Cliente", "Customer Name": "Nombre del Cliente",
  "Customer Name *": "Nombre del Cliente *", "Service": "Servicio", "Description": "Descripción",
  "Qty": "Cant.", "Rate": "Tarifa", "Price": "Precio", "Total": "Total", "Subtotal": "Subtotal",
  "Tax": "Impuesto", "Discount": "Descuento", "Deposit": "Depósito", "Balance Due": "Saldo Pendiente",
  "Credit Balance": "Saldo a Favor", "Amount Paid": "Monto Pagado", "Role": "Puesto",
  "Pay": "Pago", "Frequency": "Frecuencia", "Source": "Origen", "Interest": "Interés",
  "Preferred Contact": "Contacto Preferido", "View all": "Ver todo", "View": "Ver",
  "Tax Rate (%)": "Tasa de Impuesto (%)", "Discount ($)": "Descuento ($)", "Deposit ($)": "Depósito ($)",
  "Issue Date": "Fecha de Emisión", "Due Date": "Fecha de Vencimiento", "Add Item": "Agregar Ítem",
  "Line Items": "Conceptos", "Period": "Período", "Hours": "Horas", "Jobs": "Trabajos",

  // Statuses
  "New": "Nuevo", "Contacted": "Contactado", "Qualified": "Calificado", "Converted": "Convertido",
  "Draft": "Borrador", "Sent": "Enviado", "Approved": "Aprobado", "Declined": "Rechazado",
  "Scheduled": "Programado", "In Progress": "En Progreso", "Completed": "Completado",
  "Cancelled": "Cancelado", "Unpaid": "Sin Pagar", "Partial": "Parcial", "Paid": "Pagado",
  "Active": "Activo", "Inactive": "Inactivo", "Pending": "Pendiente",

  // Login
  "Welcome Back": "Bienvenido de Nuevo", "Sign in to your Magic Touch dashboard": "Inicia sesión en tu panel de Magic Touch",
  "Username": "Usuario", "Password": "Contraseña", "Sign In": "Iniciar Sesión", "Signing in...": "Iniciando sesión...",
  "Enter your username": "Ingresa tu usuario", "Enter your password": "Ingresa tu contraseña",
  "Please enter your username and password.": "Por favor ingresa tu usuario y contraseña.",
  "Invalid username or password.": "Usuario o contraseña inválidos.",
  "The complete management suite for premium residential & commercial cleaning.": "La suite completa de gestión para limpieza residencial y comercial premium.",

  // Dashboard
  "Welcome back — here's what's happening at Magic Touch.": "Bienvenido de nuevo — esto es lo que sucede en Magic Touch.",
  "Total Revenue": "Ingresos Totales", "Outstanding": "Pendiente", "Jobs Completed": "Trabajos Completados",
  "Active Clients": "Clientes Activos", "Open Leads": "Prospectos Abiertos", "Total Invoices": "Facturas Totales",
  "Monthly Revenue": "Ingresos Mensuales", "Upcoming Jobs": "Próximos Trabajos", "Recent Invoices": "Facturas Recientes",
  "No revenue recorded yet. Completed jobs and payments will appear here.": "Aún no hay ingresos. Los trabajos completados y pagos aparecerán aquí.",
  "No scheduled jobs.": "No hay trabajos programados.", "No invoices yet.": "Aún no hay facturas.",
  "Balance": "Saldo",

  // Customers
  "Your customer directory with full property details.": "Tu directorio de clientes con todos los detalles de la propiedad.",
  "Add Customer": "Agregar Cliente", "No customers yet": "Aún no hay clientes",
  "Add your first customer or approve an estimate to create one automatically.": "Agrega tu primer cliente o aprueba un presupuesto para crearlo automáticamente.",
  "Edit Customer": "Editar Cliente", "Add Customer ": "Agregar Cliente", "Save Customer": "Guardar Cliente",
  "Cleaning Frequency": "Frecuencia de Limpieza", "Gate Code": "Código de Acceso",
  "Parking Instructions": "Instrucciones de Estacionamiento", "Property Notes": "Notas de Propiedad",
  "Customer Notes": "Notas del Cliente", "Client name is required": "El nombre del cliente es obligatorio",
  "Customer added": "Cliente agregado", "Customer updated": "Cliente actualizado", "Customer deleted": "Cliente eliminado",
  "One-time": "Única vez", "Weekly": "Semanal", "Bi-Weekly": "Quincenal", "Monthly": "Mensual", "Quarterly": "Trimestral",
  "Text": "Mensaje",

  // Client detail
  "Back to Customers": "Volver a Clientes", "Cleaning History": "Historial de Limpieza",
  "No jobs yet": "Aún no hay trabajos", "No estimates yet": "Aún no hay presupuestos", "No invoices yet ": "Aún no hay facturas",
  "Parking": "Estacionamiento",

  // Call center / leads
  "Track inbound leads & calls and convert them into estimates.": "Da seguimiento a llamadas y prospectos y conviértelos en presupuestos.",
  "Add Lead": "Agregar Prospecto", "No leads yet": "Aún no hay prospectos",
  "Capture new prospects here. Convert a qualified lead into an estimate in one click.": "Captura nuevos prospectos aquí. Convierte un prospecto calificado en presupuesto con un clic.",
  "Edit Lead": "Editar Prospecto", "Save Lead": "Guardar Prospecto", "Service Interest": "Servicio de Interés",
  "Convert to Estimate": "Convertir a Presupuesto", "Select service": "Selecciona un servicio",
  "Lead name is required": "El nombre del prospecto es obligatorio", "Lead added": "Prospecto agregado",
  "Lead updated": "Prospecto actualizado", "Lead deleted": "Prospecto eliminado",
  "Website": "Sitio Web", "Referral": "Referido", "Google": "Google", "Social Media": "Redes Sociales",
  "Phone Call": "Llamada", "Walk-in": "Visita",

  // Services
  "Pricing, duration, and color codes for every service you offer": "Precios, duración y códigos de color para cada servicio que ofreces",
  "Add Custom Service": "Agregar Servicio", "Starting At": "Desde", "Custom": "A medida",
  "Edit Service": "Editar Servicio", "Save Service": "Guardar Servicio", "Service Name *": "Nombre del Servicio *",
  "Starting Price ($)": "Precio Inicial ($)", "Avg Duration (hrs)": "Duración Prom. (hrs)", "Color Code": "Código de Color",
  "hr avg": "hr prom", "Service name is required": "El nombre del servicio es obligatorio",
  "Service added": "Servicio agregado", "Service updated": "Servicio actualizado", "Service deleted": "Servicio eliminado",

  // Estimates
  "Build professional estimates and convert approvals into scheduled cleanings.": "Crea presupuestos profesionales y convierte las aprobaciones en limpiezas programadas.",
  "New Estimate": "Nuevo Presupuesto", "No estimates yet ": "Aún no hay presupuestos",
  "Create an estimate from scratch or convert a lead. Approved estimates auto-create a client and schedule a job.": "Crea un presupuesto desde cero o convierte un prospecto. Los presupuestos aprobados crean un cliente y programan un trabajo automáticamente.",
  "Edit Estimate": "Editar Presupuesto", "Save Estimate": "Guardar Presupuesto", "Approve & Schedule": "Aprobar y Programar",
  "Existing Client": "Cliente Existente", "New customer / select client": "Nuevo cliente / seleccionar cliente",
  "Estimate created": "Presupuesto creado", "Estimate updated": "Presupuesto actualizado", "Estimate deleted": "Presupuesto eliminado",
  "Customer name is required": "El nombre del cliente es obligatorio",
  "Estimate approved — client & scheduled job created": "Presupuesto aprobado — cliente y trabajo programado creados",

  // Schedule
  "Plan cleanings, assign crew, and complete jobs to auto-generate invoices.": "Planifica limpiezas, asigna personal y completa trabajos para generar facturas automáticamente.",
  "Schedule Job": "Programar Trabajo", "All Jobs": "Todos los Trabajos", "Today": "Hoy",
  "Assigned Employee": "Empleado Asignado", "Unassigned": "Sin Asignar", "Start": "Inicio", "End": "Fin",
  "Edit Job": "Editar Trabajo", "Save Job": "Guardar Trabajo", "Complete & Invoice": "Completar y Facturar",
  "Select client": "Selecciona un cliente", "No jobs scheduled yet.": "Aún no hay trabajos programados.",
  "Job scheduled": "Trabajo programado", "Job updated": "Trabajo actualizado", "Job deleted": "Trabajo eliminado",
  "Job completed — invoice generated": "Trabajo completado — factura generada",

  // Invoices
  "One invoice layout for preview, print, and PDF. Auto-numbered MT-####.": "Un solo diseño de factura para vista previa, impresión y PDF. Numeración automática MT-####.",
  "New Invoice": "Nueva Factura", "No invoices yet": "Aún no hay facturas",
  "Complete a scheduled job to auto-generate an invoice, or create one manually.": "Completa un trabajo programado para generar una factura automáticamente, o crea una manualmente.",
  "Edit Invoice": "Editar Factura", "Save Invoice": "Guardar Factura", "Invoice Preview": "Vista Previa de Factura",
  "Preview": "Vista Previa", "Print": "Imprimir", "Payment": "Pago", "Record Payment": "Registrar Pago",
  "Invoice created": "Factura creada", "Invoice updated": "Factura actualizada", "Invoice deleted": "Factura eliminada",
  "Payment recorded": "Pago registrado", "credit": "a favor",
  "Use your browser's 'Save as PDF' in the print dialog for an identical PDF.": "Usa 'Guardar como PDF' en el cuadro de impresión de tu navegador para un PDF idéntico.",

  // Invoice document
  "INVOICE": "FACTURA", "Bill To": "Facturar A", "Thank you for choosing": "Gracias por elegir",
  "Paid In Full": "Pagado Totalmente",

  // Payments
  "Track paid, outstanding, methods and payment dates.": "Da seguimiento a pagos, saldos, métodos y fechas.",
  "Total Collected": "Total Cobrado", "Invoices Paid": "Facturas Pagadas",
  "No payments recorded": "No hay pagos registrados",
  "Record payments from the Invoices page. They will appear here.": "Registra pagos desde la página de Facturas. Aparecerán aquí.",
  "Cash": "Efectivo", "Card": "Tarjeta", "Check": "Cheque", "Bank Transfer": "Transferencia",
  "Payment deleted": "Pago eliminado",

  // Employees
  "Manage your cleaning crew and pay rates.": "Administra tu equipo de limpieza y tarifas de pago.",
  "Add Employee": "Agregar Empleado", "No employees yet": "Aún no hay empleados",
  "Add your crew members so you can assign them to scheduled jobs.": "Agrega a tu personal para asignarlos a los trabajos programados.",
  "Edit Employee": "Editar Empleado", "Save Employee": "Guardar Empleado", "Pay Rate ($)": "Tarifa ($)",
  "Pay Type": "Tipo de Pago", "Hire Date": "Fecha de Contratación", "Hourly": "Por Hora", "Per Job": "Por Trabajo",
  "Salary": "Salario", "Cleaner": "Limpiador", "Team Lead": "Líder de Equipo", "Supervisor": "Supervisor", "Manager": "Gerente",
  "Employee name is required": "El nombre del empleado es obligatorio", "Employee added": "Empleado agregado",
  "Employee updated": "Empleado actualizado", "Employee deleted": "Empleado eliminado",

  // Payroll
  "Run payroll for your crew by pay period.": "Procesa la nómina de tu equipo por período de pago.",
  "New Payroll": "Nueva Nómina", "No payroll records": "No hay registros de nómina",
  "Create a payroll record for an employee and pay period.": "Crea un registro de nómina para un empleado y período.",
  "Edit Payroll": "Editar Nómina", "Employee *": "Empleado *", "Period Start": "Inicio del Período",
  "Period End": "Fin del Período", "Jobs Completed ": "Trabajos Completados", "Gross Pay ($)": "Pago Bruto ($)",
  "Deductions ($)": "Deducciones ($)", "Net Pay": "Pago Neto", "Select employee": "Selecciona un empleado",
  "Payroll record added": "Registro de nómina agregado", "Payroll updated": "Nómina actualizada", "Deleted": "Eliminado",

  // Reviews
  "Log and showcase client feedback for your services.": "Registra y muestra los comentarios de tus clientes.",
  "Add Review": "Agregar Reseña", "No reviews yet": "Aún no hay reseñas",
  "Capture client feedback and ratings to build social proof.": "Captura comentarios y calificaciones de clientes para generar confianza.",
  "Edit Review": "Editar Reseña", "Save Review": "Guardar Reseña", "Rating": "Calificación", "Comment": "Comentario",
  "Average rating across": "Calificación promedio de", "reviews": "reseñas",
  "No comment provided.": "Sin comentario.", "Review added": "Reseña agregada",
  "Review updated": "Reseña actualizada", "Review deleted": "Reseña eliminada",

  // Reports
  "Business insights across revenue, jobs, and clients.": "Perspectivas del negocio sobre ingresos, trabajos y clientes.",
  "Open Invoices": "Facturas Abiertas", "Top Customers by Revenue": "Mejores Clientes por Ingresos",
  "Revenue by Cleaning Service": "Ingresos por Servicio de Limpieza", "Most Popular Services": "Servicios Más Populares",
  "Outstanding Invoices": "Facturas Pendientes", "Invoice": "Factura",
  "Revenue trends will appear once payments are recorded.": "Las tendencias de ingresos aparecerán cuando se registren pagos.",
  "No customer revenue yet. Record payments to see your top customers.": "Aún no hay ingresos de clientes. Registra pagos para ver tus mejores clientes.",
  "No service revenue yet. Invoiced services will break down here.": "Aún no hay ingresos por servicio. Los servicios facturados se desglosarán aquí.",
  "Schedule jobs to see which services are booked most.": "Programa trabajos para ver qué servicios se reservan más.",
  "No outstanding invoices — all paid up!": "No hay facturas pendientes — ¡todo pagado!",
  "job": "trabajo", "jobs ": "trabajos",

  // Settings
  "Manage your company profile, branding, and invoice defaults.": "Administra el perfil de tu empresa, marca y valores de factura.",
  "Company Information": "Información de la Empresa", "Company Name": "Nombre de la Empresa",
  "Website": "Sitio Web", "Logo": "Logo", "Upload Logo": "Subir Logo",
  "PNG/JPG up to 2MB. Used across the app, invoices & print.": "PNG/JPG hasta 2MB. Se usa en la app, facturas e impresión.",
  "Invoice Settings": "Configuración de Factura", "Default Tax Rate (%)": "Tasa de Impuesto Predeterminada (%)",
  "Invoice Prefix": "Prefijo de Factura", "Invoice Terms / Footer": "Términos / Pie de Factura",
  "Theme Colors": "Colores del Tema", "Primary": "Primario", "Secondary": "Secundario", "Accent": "Acento",
  "Backup & Export": "Respaldo y Exportación",
  "Download a full JSON backup of your clients, invoices, payments and jobs.": "Descarga un respaldo JSON completo de clientes, facturas, pagos y trabajos.",
  "Export Data": "Exportar Datos", "Settings saved": "Configuración guardada",
  "Appearance": "Apariencia", "Theme": "Tema", "Light Mode": "Modo Claro", "Dark Mode": "Modo Oscuro",
  "Language": "Idioma", "English": "Inglés", "Spanish": "Español",
  "Choose how Magic Touch looks and the language of the interface.": "Elige cómo se ve Magic Touch y el idioma de la interfaz.",
  "Backup exported": "Respaldo exportado",

  // Table headers / misc
  "Invoice #": "Factura #", "Estimate #": "Presupuesto #", "Gross": "Bruto",
  "Could not save settings": "No se pudo guardar la configuración",
  "Could not export data": "No se pudieron exportar los datos",
};

export function translate(lang, s) {
  if (lang === "es" && ES[s] != null) return ES[s];
  return s;
}
